module.exports = __webpack_public_path__ + "static/media/work-office-building.42dbbb7f.svg";